export enum FootfallGranularity {
    Month = "month",
    Quarter = "quarter",
    Year = "year"
}
